var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92 6.788L14.708 0l1.131 1.131L9.051 7.92l6.788 6.788-1.131 1.131L7.92 9.051 1.13 15.839 0 14.708 6.788 7.92 0 1.13 1.131 0 7.92 6.788z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KPHBhdGggZD0iTTcuOTIgNi43ODhMMTQuNzA4IDBsMS4xMzEgMS4xMzFMOS4wNTEgNy45Mmw2Ljc4OCA2Ljc4OC0xLjEzMSAxLjEzMUw3LjkyIDkuMDUxIDEuMTMgMTUuODM5IDAgMTQuNzA4IDYuNzg4IDcuOTIgMCAxLjEzIDEuMTMxIDAgNy45MiA2Ljc4OHoiIC8+Cjwvc3ZnPgo=";
export { SvgClose as ReactComponent };